

















import { Component, Mixins, Prop } from "vue-property-decorator";
import { UnmanagedLoginView } from "../authentication";
import { PatientDocumentListViewer } from "./viewers/wizard/guest";

@Component({
  components: {
    UnmanagedLoginView,
    PatientDocumentListViewer,
  }
})
export default class GuestWizardPatientDocumentListView extends Mixins() {
  @Prop()
  userCode: string;

  @Prop()
  departmentCode: string;

  @Prop()
  hostName: string;

  @Prop()
  patientNo: string;

  @Prop()
  shouldAuthenticateLater: boolean;

  @Prop()
  shouldSelectDepartment: boolean;
}
